const IMAGES = {
  0: require("../img/poza.jpeg"),
  1: require("../img/education.jpg"),
  2: require("../img/QPillars-logo.png"),
  3: require("../img/microsoft.jpeg"),
  4: require("../img/moisil.jpg"),
  5: require("../img/tutoring.png"),
};

export default IMAGES;
